import React, { useEffect, useState } from 'react'
import { Select } from '@st-operations/uikit/src/v2'

import './styles.scss'
import { getEventFeeds } from '_services/data-explorer'

export const FIXED_VALUES = {
  NO_FILTERS: 'No Filters',
}
export const FIXED_VALUES_OPTIONS = [
  { label: FIXED_VALUES.NO_FILTERS, value: FIXED_VALUES.NO_FILTERS },
]

const IndexBaselineSelect = ({ style, indexBaseline, onIndexBaselineChange }) => {
  const [eventFeeds, setEventFeeds] = useState()

  useEffect(() => {
    getEventFeeds().then((result) => {
      setEventFeeds(result.items)
    })
  }, [])

  return (
    <div className="interval-select">
      <Select
        style={{ ...style }}
        label="Index Baseline"
        options={[
          {
            label: 'Filters',
            options: FIXED_VALUES_OPTIONS,
          },
          {
            label: 'Feeds',
            options: eventFeeds?.map((ef) => ({ label: ef.name, value: ef._id })) || [],
          },
        ]}
        value={indexBaseline}
        onChange={(value) => onIndexBaselineChange(value)}
        useReactSelect
      />
    </div>
  )
}

export default IndexBaselineSelect
